import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import {
  Button,
  GDSIconSource,
  Icon,
  VisuallyHidden,
} from '@leagueplatform/genesis-core';

interface NavButtonProps {
  disabled: boolean;
  onClick: () => void;
  label: string;
  icon: GDSIconSource;
}

interface BackAndForwardNavButtonProps
  extends Omit<NavButtonProps, 'label' | 'icon'> {}

const NavButton = ({ disabled, onClick, label, icon }: NavButtonProps) => (
  <Button
    disabled={disabled}
    onClick={onClick}
    priority="secondary"
    css={{
      borderRadius: '$circle',
      width: '$two',
      height: '$two',
      padding: '$none',
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'visibility 300ms, opacity 300ms',
    }}
  >
    <Icon size={16} icon={icon} css={{ display: 'flex' }} />
    <VisuallyHidden>{label}</VisuallyHidden>
  </Button>
);

export const BackNavButton = ({
  disabled,
  onClick,
}: BackAndForwardNavButtonProps) => {
  const { formatMessage } = useIntl();
  return (
    <NavButton
      disabled={disabled}
      onClick={onClick}
      label={formatMessage({ id: 'PREVIOUS' })}
      icon="interfaceArrowBack"
    />
  );
};

export const ForwardNavButton = ({
  disabled,
  onClick,
}: BackAndForwardNavButtonProps) => {
  const { formatMessage } = useIntl();
  return (
    <NavButton
      disabled={disabled}
      onClick={onClick}
      label={formatMessage({ id: 'NEXT' })}
      icon="interfaceArrowForward"
    />
  );
};
